import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UnitsStore } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { convertCelsiusToFahrenheit } from '../../../../../../shared/common/units';
import { SUFFIX } from '../../../../../../shared/common/units';

@Component({
  selector: 'app-vdd-number-readonly',
  templateUrl: './vdd-number-readonly.component.html',
  styleUrls: ['./vdd-number-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddNumberReadonlyComponent implements OnInit, OnDestroy {
  @Input() value: string | number;
  @Input() unit: string;
  @Input() label: string;
  @Input() isVersion: boolean;
  @Input() isNextValueVersion: boolean;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private unitsStore: UnitsStore) {}

  ngOnInit(): void {
    this.unitsStore.isTemperatureMetric$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isCelsius) => {
        if (!isCelsius && this.unit === SUFFIX.celsius) {
          this.unit = SUFFIX.fahrenheit;
          this.value = convertCelsiusToFahrenheit(Number(this.value)).toFixed(1);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
